quoteModule.factory("ListItemSetup", function() {
    var ListItemSetup = function(prop){
        this.listItems = [];
        this.selectedVal = null;
        this.selectedItem = null;
        this.propertyName = prop;
    }

    //validation of deal data for saving a quote.. not much here because we really don't
    // require deal data to save a quote
    ListItemSetup.prototype.clearItems = function() {
        listItems = [];
        selectedVal = null;
        selectedItem = null;
    }

    return ListItemSetup;
});